export enum CustomerMessages {
  applicationDashboard = "customer.application.dashboard",
  applicationConcretingRequest = "customer.application.concretingRequest",
  applicationConcretingRequestAbbreviated = "customer.application.concretingRequest.abbreviated",
  applicationContract = "customer.application.contract",
  applicationConcreting = "customer.application.concreting",
  applicationInvoice = "customer.application.invoice",
  applicationConcretingApproval = "customer.application.concretingApproval",
  applicationCertificate = "customer.application.certificate",
  applicationContractAmounts = "customer.application.contractAmounts",
  applicationClient = "customer.application.client",
  applicationPermission = "customer.application.permission",
  applicationLogout = "customer.application.logout",
  applicationSettings = "customer.application.settings",
  allUsersStatusIconTitle = "customer.allUsersStatus.iconTitle",
  newUsersStatusIconTitle = "customer.newUsersStatus.iconTitle",
  activeUsersStatusIconTitle = "customer.activeUsersStatus.iconTitle",
  inactiveUsersStatusIconTitle = "customer.inactiveUsersStatus.iconTitle",
  blockedUsersStatusIconTitle = "customer.blockedUsersStatus.iconTitle",
  inactivedUser = "customer.inactiveUser",
  activedUser = "customer.activeUser",
  errorInactivatingUser = "customer.error.inactiveUser",
  errorActivatingUser = "customer.error.activeUser",
  inactivateUserTitle = "customer.title.inactivate",
  activateUserTitle = "customer.title.activate",
  inactivateUserText = "customer.text.inactivate",
  activateUserText = "customer.text.activate",
  inactivateUserButton = "customer.button.inactivate",
  activateUserButton = "customer.button.activate"
}

export interface TranslationCustomerMessages {
  [CustomerMessages.applicationDashboard]: string;
  [CustomerMessages.applicationConcretingRequest]: string;
  [CustomerMessages.applicationConcretingRequestAbbreviated]: string;
  [CustomerMessages.applicationContract]: string;
  [CustomerMessages.applicationContractAmounts]: string;
  [CustomerMessages.applicationConcreting]: string;
  [CustomerMessages.applicationInvoice]: string;
  [CustomerMessages.applicationConcretingApproval]: string;
  [CustomerMessages.applicationCertificate]: string;
  [CustomerMessages.applicationClient]: string;
  [CustomerMessages.applicationPermission]: string;
  [CustomerMessages.applicationLogout]: string;
  [CustomerMessages.applicationSettings]: string;
  [CustomerMessages.allUsersStatusIconTitle]: string;
  [CustomerMessages.newUsersStatusIconTitle]: string;
  [CustomerMessages.activeUsersStatusIconTitle]: string;
  [CustomerMessages.inactiveUsersStatusIconTitle]: string;
  [CustomerMessages.blockedUsersStatusIconTitle]: string;
  [CustomerMessages.inactivedUser]: string;
  [CustomerMessages.activedUser]: string;
  [CustomerMessages.errorInactivatingUser]: string;
  [CustomerMessages.errorActivatingUser]: string;
  [CustomerMessages.inactivateUserTitle]: string;
  [CustomerMessages.activateUserTitle]: string;
  [CustomerMessages.inactivateUserText]: string;
  [CustomerMessages.activateUserText]: string;
  [CustomerMessages.inactivateUserButton]: string;
  [CustomerMessages.activateUserButton]: string;
}
